// removed by extract-text-webpack-plugin
module.exports = {"topStoreContainer":"topStoreContainer__3UogJ","enrichCategoriesCardWrapper":"enrichCategoriesCardWrapper__3pN7q"};


//////////////////
// WEBPACK FOOTER
// ./componentsBICRevamp/buyWithInstacredLanding/campaignSpecificCategories/style.css
// module id = +BiO
// module chunks = 323